import React from "react";
import { Box, Typography, Button, TextField, Container, Link } from "@mui/material";
import IpadImage from "./images/IpadImage-2.png";

export default function LPFirstComponent(props) {
    const { isSmallScreen } = props;
    
    return (
        <Box
            sx={{
                minHeight: "60vh",
                background: "linear-gradient(135deg, #4b0c5c 0%, #8a0f6b 100%)",
                color: "white",
                display: "flex",
                alignItems: "center",
            }}
        >
            <Container maxWidth="lg">
                <Box sx={{ display: "flex", alignItems: "center", gap: 4, margin: isSmallScreen && "1.7rem" }}>
                    {/* LEFT CONTENT */}
                    <Box sx={{ flex: 1 }}>
                        <Typography
                            variant="h3"
                            sx={{ fontWeight: 300, mb:isSmallScreen ? 3 : 4, lineHeight: 1.2, fontFamily: "Poppins", fontSize: isSmallScreen && "2rem"  }}
                        >
                            Skills Today. A Brighter Tomorrow
                        </Typography>

                        <Typography sx={{ mb: isSmallScreen ? 3 : 4, opacity: 0.8, fontFamily: "Poppins", fontSize: isSmallScreen && "0.7rem" }}>
                            1,00,000+  alumni have achieved success – what about you?
                        </Typography>

                        <Typography sx={{ opacity: 0.8, fontFamily: "Poppins" , fontSize: isSmallScreen && "0.7rem" }}>
                            Ranked #1 DevOps Institute by{" "}
                            <a
                                href="https://www.deccanherald.com/brandspot/featured/paperlive-learning-the-no1-devops-institute-in-india-3197872"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    background: "rgba(255,255,255,0.15)",
                                    color: "#fff",
                                    padding: "2px 8px",
                                    borderRadius: "6px",
                                    textDecoration: "none",
                                    fontWeight: 600,
                                    border: "1px solid rgba(255,255,255,0.3)"
                                }}
                            >
                                Deccan Herald
                            </a>
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                gap: 6,
                                mt: isSmallScreen ? 4 : 8,
                                flexWrap: "wrap",
                            }}
                        >
                            {/* GOOGLE */}
                            <Box sx={{ textAlign: "center" }}>
                                <Typography sx={{ color: "#FFA81D", fontSize: isSmallScreen? "10px" : "15px" }}>
                                    ★★★★★
                                </Typography>
                                <Typography sx={{ fontWeight: 500, fontFamily: "Poppins" }}>
                                    <img src="https://1000logos.net/wp-content/uploads/2021/05/Google-logo.png" alt="Google" style={{ height: isSmallScreen ? "25px" : "40px", verticalAlign: "middle", margin: 5 }} />
                                </Typography>
                                <Typography sx={{ opacity: 0.6, fontSize: isSmallScreen? "9px" : "14px" }}>
                                    5.0-star rating
                                </Typography>
                            </Box>

                            {/* LINKEDIN */}
                            <Box sx={{ textAlign: "center" }}>
                                <Typography sx={{ color: "#FFA81D", fontSize: isSmallScreen? "10px" : "15px" }}>
                                    ★★★★★
                                </Typography>
                                <Typography sx={{ fontWeight: 500, fontFamily: "Poppins" }}>
                                    <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/YouTube_Logo_%282013-2017%29.svg/1280px-YouTube_Logo_%282013-2017%29.svg.png?utm_source=meta.wikimedia.org&utm_campaign=index&utm_content=thumbnail" alt="Youtube" style={{ height: isSmallScreen? "18px" : "30px", verticalAlign: "middle", margin: 10 }} />
                                </Typography>
                                <Typography sx={{ opacity: 0.6, fontSize: isSmallScreen? "9px" : "14px"}}>
                                    5.0-star rating
                                </Typography>
                            </Box>

                            {/* YOUTUBE */}
                            <Box sx={{ textAlign: "center" }}>
                                <Typography sx={{ color: "#FFA81D", fontSize: isSmallScreen? "10px" : "15px"}}>
                                    ★★★★★
                                </Typography>
                                <Typography sx={{ fontWeight: 500, fontFamily: "Poppins" }}>
                                    <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/LinkedIn_Logo.svg/3840px-LinkedIn_Logo.svg.png" alt="LinkedIn" style={{ height: isSmallScreen? "15px" : "30px", verticalAlign: "middle", margin: 10 }} />
                                </Typography>
                                <Typography sx={{ opacity: 0.6, fontSize: isSmallScreen? "9px" : "14px" }}>
                                    5.0-star rating
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    { !isSmallScreen &&
                    <Box
                        sx={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            marginRight: "-10%",
                        }}
                    >
                        <img
                            src={IpadImage}
                            alt="tablet"
                            style={{
                                width: "120%",
                                // maxWidth: "3000px",
                            }}
                        />
                    </Box>
                    }
                </Box>
                { isSmallScreen &&
                    <Box
                        sx={{
                            flex: 1,
                            display: "flex",
                            justifyContent: !isSmallScreen && "flex-end",
                            alignItems: "center",
                            marginRight: isSmallScreen ? "" : "-10%",
                        }}
                    >
                        <img
                            src={IpadImage}
                            alt="tablet"
                            style={{
                                width: isSmallScreen? "80%" : "120%",
                                // maxWidth: "3000px",
                            }}
                        />
                    </Box>
                    }
            </Container>
        </Box>
    );
}